import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import messages from "../../../assets/locale/messages";
import Breadcrumbs from "../../../components/BreadCrumbs";
import { TabSetsLevels } from "../../../components/ui";
import { companyPermissionModules } from "../../../utils/Constants";
import { canViewCompanyModules } from "../../../utils/Permissions";
import EmployeesManagement from "./EmployeesManagement";
import RolesManagement from "./RolesManagement";

import "./TeamsPermissions.scss";

export const TEAM_TABS = {
  employees: "employees",
  roles: "roles",
};

const TeamsPermissions = () => {
  const lang = useSelector((state) => state.locale.lang);
  const login = useSelector((state) => state.auth.login);
  const copy = messages[lang].teamManagement;
  const location = useLocation();

  const canViewEmployees = canViewCompanyModules(
    companyPermissionModules.employees,
    login,
  );
  const canViewRoles = canViewCompanyModules(
    companyPermissionModules.rolesManagement,
    login,
  );

  const initialTab =
    new URLSearchParams(location.search).get("tab") === TEAM_TABS.roles
      ? TEAM_TABS.roles
      : TEAM_TABS.employees;
  const [activeTab, setActiveTab] = useState(initialTab);

  const tabs = useMemo(() => {
    const next = [];
    if (canViewEmployees) {
      next.push({ value: TEAM_TABS.employees, label: copy.tabs.employees });
    }
    if (canViewRoles) {
      next.push({ value: TEAM_TABS.roles, label: copy.tabs.roles });
    }
    return next;
  }, [canViewEmployees, canViewRoles, copy.tabs.employees, copy.tabs.roles]);

  useEffect(() => {
    if (!tabs.length) return;
    if (!tabs.some((tab) => tab.value === activeTab)) {
      setActiveTab(tabs[0].value);
    }
  }, [tabs, activeTab]);

  const breadcrumbList = [{ path: "", label: copy.title }];

  return (
    <div className="team-management">
      <div className="mt-2">
        <Breadcrumbs list={breadcrumbList} BreadCrumbHasBackIcon={false} />
      </div>

      {tabs.length > 1 && (
        <TabSetsLevels
          tabs={tabs}
          value={activeTab}
          onChange={setActiveTab}
          className="team-management__tabs"
        />
      )}

      {activeTab === TEAM_TABS.employees && canViewEmployees ? (
        <EmployeesManagement />
      ) : canViewRoles ? (
        <RolesManagement />
      ) : null}
    </div>
  );
};

export default TeamsPermissions;
